import * as React from 'react'
import {connect} from 'react-redux'
import {Button, CardBody, CardImg, Col, Modal, ModalBody, ModalFooter, Row} from "reactstrap";
import {
    ConfiguratorProduct,
    ProductFamilyIconsInner,
    Product
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {extractLeasingPerMonth, extractPrice, extractRentPerMonth} from "App/services";
import {Currency, CurrencyProps, DATE_FORMAT, Language, LinkType} from "App/constants";
import {Basket} from "App/basket";
import {scroller} from "react-scroll"
import {selectOfferPageAction, selectContractPageAction} from "App/routes";
import {UserState} from "App/user";
import {RefObject} from "react";
import {startLogin} from "App/services/reducers/auth";
import moment from 'moment';
import {Spinner} from "App/fragments/Spinner";
import {Ribbon} from "App/fragments/Ribbon";
import {ContactInfo} from "Components/ContactInfo";
import {selectedLang} from "App/helper";
import {ImageCard} from "Components/ImageCard";

interface StateToProps extends CurrencyProps {
    subcategory: ProductFamilyIconsInner
    product: Product
    configuration: ConfiguratorProduct;
    basket: Basket;
    user: UserState | null;
}

interface ComponentState {
    isSpecialDiscountImageVisible: boolean
}

interface DispatchToProps {
    onContract: (basket: Basket, language: Language, currency: Currency) => void
    onOffer: (basket: Basket, language: Language, currency: Currency) => void
    onStartLogin: () => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
    onContract: (basket: Basket, language: Language, currency: Currency) => dispatch(selectContractPageAction()),
    onOffer: (basket: Basket, language: Language, currency: Currency) => dispatch(selectOfferPageAction()),
    onStartLogin: () => dispatch(startLogin())
});

function initialState(props: StateToProps): ComponentState {
    return {
        isSpecialDiscountImageVisible: false
    }
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    detailCard: RefObject<any>;
    linkRent: RefObject<any>;
    linkLeasing: RefObject<any>;

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
        this.scrollTo = this.scrollTo.bind(this);
        this.linkRent = React.createRef();
        this.linkLeasing = React.createRef();
        this.detailCard = React.createRef();
    }

    scrollTo(linkType: LinkType, offsetRef: RefObject<any> | null) {
        const offset = offsetRef ? this.detailCard.current.getBoundingClientRect().y - 20 - offsetRef.current.getBoundingClientRect().y : -20;
        scroller.scrollTo(linkType, {offset: offset, smooth: true, duration: 300})
    }

    render() {
        const {
            subcategory, product, configuration, i18n, currency, basket,
            t, onOffer, onContract, onStartLogin, user
        } = this.props;
        const alternativeprice: number | null = configuration.alternativeused && extractPrice(configuration.alternativeused[0].price, currency);
        const language: Language = selectedLang(i18n);

        return <div ref={this.detailCard} className="card">
            {basket.specialdiscount ? <Ribbon className={"ribbon-normal-" + language}/> : null}
            <CardBody className="bodyslice pb-1 ie11quirks">
                <div className="title-small-uppercase">{subcategory.nameml[language]}</div>
                <div className="title-large-uppercase">{configuration.nameml[language]}</div>
                <ImageCard product={product} configuration={configuration} className={"d-block d-lg-none"}/>
                <CardImg src={product.iconurl} alt={configuration.nameml[language]}
                         className="p-0 card-image-small mx-auto d-lg-block d-none"/>
            </CardBody>
            <CardBody className="bodyslice">
                <Row className="no-gutters pb-1">
                    <Col className="col-md-6 align-self-center">
                        <div className="text-normal-overview">{t('products.configuration.pricelabel')}</div>
                    </Col>
                    <Col className="col-md-6 d-flex justify-content-end">
                        <Spinner active={basket.syncState.pending}/>
                        <div
                            className={"pl-1 d-inline text-bold-uppercase-overview text-right " + (basket.syncState.pending ? "updating" : "")}>{t('products.configuration.price', {
                            amount: (basket.totalprice ? basket.totalprice : '-'),
                            unit: currency
                        })}</div>
                    </Col>
                </Row>
                {user && !basket.specialdiscount ?
                    null :
                    <React.Fragment>
                        <Row className="align-items-center no-gutters">
                            {basket.specialdiscount?
                                (basket.specialdiscount.remainingquantity||basket.specialdiscount.remainingquantity==0?
                                    (basket.specialdiscount.remainingquantity==0?
                                        <Col className="text-left pb-1">
                                            <span className="discount text-bold-overview align-middle">{t('products.configuration.specialdiscountterminated')}</span>
                                        </Col>:
                                        <Col className="text-left pb-1">
                                            <span className="discount text-bold-small-overview align-middle">{t('products.configuration.specialdiscountqty', {count: basket.specialdiscount.remainingquantity||0})}</span>
                                        </Col>):
                                    <Col className="text-left pb-1">
                                        <span className="discount text-bold-small-overview align-middle">{t('products.configuration.specialdiscount', {enddate: moment(basket.specialdiscount.enddate).format(DATE_FORMAT)})}</span>
                                    </Col>):
                                <Col className="text-right pb-1">
                                        <span className="action pr-2 text-bold-small-overview align-middle"
                                              onClick={() => onStartLogin()}>{t('products.configuration.requestdiscount')}</span>
                                    <i className="action fal fa-lg fa-badge-percent align-middle"></i>
                                </Col>
                            }
                        </Row>
                        {
                            basket.specialdiscount ?
                                <React.Fragment>
                                    <Row className="pb-3 pb-lg-1 no-gutters">
                                        <Col className="col-md-6 align-self-center">
                                            <i className=" far fa-lg fa-file-alt discount doc align-middle"
                                               onClick={() => this.setState({isSpecialDiscountImageVisible: true})}></i>
                                            <div
                                                className="d-inline pl-2 discount text-bold-small-overview">{t('products.configuration.standardpricelabel')}</div>
                                        </Col>
                                        <Col className="col-md-6 d-flex justify-content-end">
                                            <div
                                                className={"discount pl-1 d-inline text-bold-small-overview text-right "}>{t('products.configuration.price', {
                                                amount: basket.standardprice,
                                                unit: currency
                                            })}</div>
                                        </Col>
                                    </Row>
                                    <Modal isOpen={this.state.isSpecialDiscountImageVisible} className={"mt-6"}>
                                        <ModalBody>
                                            <CardImg src={basket.specialdiscount.imageurl} className="p-0"/>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                className="configure text-uppercase text-left button-height-48 d-flex align-items-center"
                                                onClick={() => this.setState({isSpecialDiscountImageVisible: false})}>
                                                <div className={"d-inline pl-2"}>{t('products.configuration.dismiss')}</div>
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                </React.Fragment> :
                                null
                        }
                    </React.Fragment>
                }
                <Row className="align-items-center py-2 no-gutters d-lg-block d-none">
                    <Col>
                        <Button className="configure w-100 text-uppercase text-left"
                                onClick={() => onContract(basket, language, currency)} disabled={!basket.machineid}>
                            <i className="far fa-check-circle pr-2 fa-lg"></i>{t('products.configuration.contract')}
                        </Button>
                    </Col>
                </Row>
                <Row className="align-items-center pt-1 pb-3 no-gutters d-lg-block d-none">
                    <Col>
                        <Button className="advice w-100 text-uppercase text-left"
                                onClick={() => onOffer(basket, language, currency)} disabled={!basket.machineid}>
                            <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{t('products.configuration.offer')}
                        </Button>
                    </Col>
                </Row>
            </CardBody>
            {
                basket.rent || configuration.minrentpermonth ?
                    <div ref={this.linkRent} className="bodyslice py-2 px-0 mx-4 card-body">
                        <Row className="no-gutters">
                            <Col className="col-md-6 align-self-center">
                                <a className="btn btn-secondary other w-100 text-uppercase text-left"
                                   onClick={() => this.scrollTo(LinkType.RENT_SECTION, this.linkRent)}>
                                    <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{t('products.configuration.rent')}
                                </a>
                            </Col>
                            <Col className="col-md-6 align-self-center">
                                {(basket.rent && basket.rent.monthlyrate) || configuration.minrentpermonth ?
                                    <div
                                        className="m-0 text-right text-normal-overview">{t('products.configuration.rentprice', {
                                        amount: basket.rent && basket.rent.monthlyrate ? basket.rent.monthlyrate : extractRentPerMonth(configuration.minrentpermonth, currency),
                                        unit: currency
                                    })}</div> :
                                    <div className="m-0 text-right text-normal-overview">
                                        <i className="fas fa-spinner fa-pulse"></i>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </div>
                    : null
            }
            {
                basket.leasing || configuration.minleasingpermonth ?
                    <div ref={this.linkLeasing} className="bodyslice py-2 px-0 mx-4 card-body">
                        <Row className="no-gutters">
                            <Col className="col-md-6 align-self-center">
                                <a className="btn btn-secondary other w-100 text-uppercase text-left"
                                   onClick={() => this.scrollTo(LinkType.LEASIG_SECTION, this.linkLeasing)}>
                                    <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{t('products.configuration.lease')}
                                </a>
                            </Col>
                            <Col className="col-md-6 align-self-center">
                                {(basket.leasing && basket.leasing.monthlyrate) || configuration.minleasingpermonth ?
                                    <div
                                        className="m-0 text-right text-normal-overview">{t('products.configuration.leaseprice', {
                                        amount: basket.leasing && basket.leasing.monthlyrate ? basket.leasing.monthlyrate : extractLeasingPerMonth(configuration.minleasingpermonth, currency),
                                        unit: currency
                                    })}</div> :
                                    <div className="m-0 text-right text-normal-overview">
                                        <i className="fas fa-spinner fa-pulse"></i>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </div>
                    : null
            }
            {
                configuration.alternativeused && configuration.alternativeused.length ?
                    <div className="bodyslice py-2 card-body">
                        <Row className="no-gutters">
                            <Col className="col-md-6 align-self-center">
                                <a className="btn btn-secondary other w-100 text-uppercase text-left"
                                   onClick={() => this.scrollTo(LinkType.USED_SECTION, null)}>
                                    <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{t('products.configuration.occasion')}
                                </a>
                            </Col>
                            <Col className="col-md-6 align-self-center">
                                <div
                                    className="m-0 text-right text-normal-overview">{alternativeprice ? t('products.configuration.occasionprice', {
                                    amount: alternativeprice,
                                    unit: currency
                                }) : t('products.configuration.priceonrequest')}</div>
                            </Col>
                        </Row>
                    </div>
                    : null
            }

            <ContactInfo basket={basket} user={user} configuration={configuration}/>
        </div>
    }
}

export const ConfiguratorOverviewPage = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));



// WEBPACK FOOTER //
// ./src/components/ConfiguratorOverview.tsx